import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import SwipeableViews from 'react-swipeable-views';
import { Badge, Box, Tab, Tabs } from '@mui/material';
import { preventDefault } from 'shared/hooks/utils';
import { updateDateLastNewsRead } from 'console/redux/news/actions';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { ImportantEventsList } from './components/list';
import { NewsList } from './components/news';
const tabs_names = [
    { id: 0, label: 'Важные события' },
    { id: 1, label: 'Новости' },
];
export const ImportantEventAndNews = memo(function ImportantEventAndNews(props) {
    const { important_events, devid2name, onClose, unread_news_count, important_events_count, onChangeLabel, } = props;
    const news = useAppSelector((state) => state.news.news_list);
    const updateLastNewsRead = useAction(updateDateLastNewsRead);
    const [tab_index, setTabIndex] = useState(0);
    const onChangeIndex = useCallback((new_index) => {
        setTabIndex(new_index);
        if (new_index == 1) {
            updateLastNewsRead();
        }
        onChangeLabel(tabs_names.find(({ id }) => id == new_index)?.label ?? 'Важные события');
    }, [setTabIndex, updateLastNewsRead, onChangeLabel, tabs_names]);
    const onChangeTabs = useCallback((event, new_index) => {
        preventDefault(event);
        onChangeIndex(new_index);
    }, [onChangeIndex]);
    return (_jsx(ErrorBoundary, { children: _jsxs(Box, { display: "flex", flexDirection: "column", height: "100%", overflow: "auto", justifyContent: "flex-start", alignContent: "center", children: [_jsx(Box, { mb: 1, children: _jsxs(Tabs, { value: tab_index, onChange: onChangeTabs, centered: true, indicatorColor: "primary", textColor: "primary", variant: "standard", children: [_jsx(Tab, { label: _jsx(Badge, { badgeContent: important_events_count, color: "error", invisible: important_events_count === 0, max: 99, children: tabs_names[0].label }, tabs_names[0].id) }), _jsx(Tab, { label: _jsx(Badge, { badgeContent: unread_news_count, color: "error", invisible: unread_news_count === 0, max: 99, children: tabs_names[1].label }, tabs_names[1].id) })] }) }), _jsxs(SwipeableViews, { index: tab_index, onChangeIndex: onChangeIndex, style: {
                        display: 'flex',
                        flexGrow: 1,
                        flexDirection: 'column',
                    }, containerStyle: {
                        flexGrow: 1,
                        height: '100%',
                    }, children: [tab_index === 0 ? (_jsx(ImportantEventsList, { important_events: important_events, devid2name: devid2name, onClose: onClose })) : (_jsx("div", {})), tab_index === 1 ? (_jsx(NewsList, { news: news, unread: unread_news_count })) : (_jsx("div", {}))] })] }) }));
});
